import React, { ReactElement } from "react";

import CustomerSimplifiedDTO from "../dtos/CustomerSimplifiedDTO";

import CustomerSimplified from "./CustomerSimplified";

interface IProps {
  customers: CustomerSimplifiedDTO[];
  selectCustomerHandler: (customer: CustomerSimplifiedDTO) => void;
}

const CustomerSelectList: React.FC<IProps> = (props) => {
  // props destruct
  const { customers, selectCustomerHandler } = props;

  // render methods
  const renderCustomers = (): Array<ReactElement> => {
    return customers.map((customer, index) => (
      <div className="col-md-6 px-2" key={index}>
        <CustomerSimplified customer={customer} selectCustomerHandler={selectCustomerHandler} />
      </div>
    ));
  };

  return (
    <div className="row no-gutters mx-n2">
      {renderCustomers()}
    </div>
    );
};

export default CustomerSelectList;
